"use strict";
import { Suspense, useDeferredValue } from "react";
export const SuspenseWithPreviousRenderAsFallback = (props) => {
  const previousChildren = useDeferredValue(props.children);
  return <Suspense fallback={previousChildren ?? null}>{props.children}</Suspense>;
};
